var components
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.label, function(item, index) {
    var g0 = _vm.labelCheck.indexOf(item)
    return {
      $orig: _vm.__get_orig(item),
      g0: g0
    }
  })

  if (!_vm._isMounted) {
    _vm.e0 = function($event) {
      _vm.show = !_vm.show
    }

    _vm.e1 = function($event) {
      _vm.show = false
    }
  }

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0
      }
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }